import React from 'react';

interface BreathPillProps {
  paused: boolean;
  onPauseToggle: () => void;
  onExit: () => void;
  onFullscreen: () => void;
  taskCompleted: boolean;
  onTaskToggle: () => void;
  hidden?: boolean;
  volume?: number;
  onVolumeChange?: (volume: number) => void;
  onAddTask?: () => void;
  hasTask?: boolean;
  chimeOn?: boolean;
  onChimeToggle?: () => void;
}

// Edge controls: a single quiet line of text that only surfaces on intent.
const BreathPill: React.FC<BreathPillProps> = ({
  paused,
  onPauseToggle,
  onExit,
  onFullscreen,
  taskCompleted,
  onTaskToggle,
  hidden = false,
  volume = 50,
  onVolumeChange,
  onAddTask,
  hasTask = true,
  chimeOn,
  onChimeToggle,
}) => {
  return (
    <nav
      className={`th-controls ${hidden ? 'is-hidden' : ''}`}
      aria-label="Session controls"
    >
      <button onClick={onPauseToggle}>
        {paused ? 'resume' : 'pause'} <kbd>space</kbd>
      </button>

      {hasTask && !taskCompleted && (
        <button onClick={onTaskToggle}>
          done <kbd>t</kbd>
        </button>
      )}

      {onAddTask && (
        <button onClick={onAddTask}>
          add task <kbd>a</kbd>
        </button>
      )}

      {onVolumeChange && (
        <label className="th-volume">
          music
          <input
            type="range"
            min="0"
            max="100"
            value={volume}
            onChange={(e) => onVolumeChange(parseInt(e.target.value, 10))}
            aria-label="Music volume"
          />
        </label>
      )}

      {onChimeToggle && (
        <button
          onClick={onChimeToggle}
          aria-pressed={chimeOn}
          title="a quiet chime when someone sits down"
        >
          chime {chimeOn ? 'on' : 'off'}
        </button>
      )}

      <button onClick={onFullscreen}>
        fullscreen <kbd>f</kbd>
      </button>

      <button onClick={onExit} className="th-controls-leave">
        leave <kbd>esc</kbd>
      </button>
    </nav>
  );
};

export default BreathPill;
